import { create } from 'zustand';

interface GlobalFiltersState {
  languageCode: string;
  setLanguageCode: (languageCode: string) => void;
}

export const useGlobalFiltersStore = create<GlobalFiltersState>((set) => ({
  languageCode: '',
  setLanguageCode: (languageCode: string) => set({ languageCode }),
}));
